import request from '@/router/axios'

export function fetchTree(query) {
  return request({
    url: '/dept/tree',
    method: 'post',
    params: query
  })
}

export function fetchDept(query) {
  return request({
    url: '/dept/',
    method: 'post',
    params: query
  })
}

export function addObj(obj) {
  return request({
    url: '/dept/add',
    method: 'post',
    params: obj
  })
}

export function getObj(id) {
  return request({
    url: '/dept/info/',
    method: 'post',
    params: id
  })
}

export function delObj(id) {
  return request({
    url: '/dept/del',
    method: 'post',
    params : id
  })
}

export function putObj(obj) {
  return request({
    url: '/dept/update',
    method: 'post',
    params : obj
  })
}
export function getchild(obj) {
  return request({
    url: '/dept/getChildren',
    method: 'post',
    params : obj
  })
}

